export default "__VITE_ASSET__JY9GdLss__"